// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-list .wechat-image img {\n  width: 200px !important;\n  height: 200px !important;\n}", ""]);
// Exports
module.exports = exports;
